export const GAME_AUTH = 'GAME_AUTH';
export const GAME_START = 'GAME_START';
export const GAME_RESET = 'GAME_RESET';
export const GAME_END = 'GAME_END';
export const BUTTON_PRESSED = 'BUTTON_PRESSED';
export const TARGET_TOUCHED = 'TARGET_TOUCHED';
export const SET_THEME = 'SET_THEME';
export const UPDATE_PLAYERS = 'UPDATE_PLAYERS';
